// extracted by mini-css-extract-plugin
export default {"common":"TasksSkeleton_common__FGjkb","tasks":"TasksSkeleton_tasks__5T2DD TasksSkeleton_common__FGjkb"};